import { render, staticRenderFns } from "./VIPCoupon.vue?vue&type=template&id=67214f76&scoped=true&"
import script from "./VIPCoupon.vue?vue&type=script&lang=js&"
export * from "./VIPCoupon.vue?vue&type=script&lang=js&"
import style0 from "./VIPCoupon.vue?vue&type=style&index=0&id=67214f76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67214f76",
  null
  
)

export default component.exports